
import { Badge } from "@/components/ui/badge";
import { QuoteStatus } from "@/types/quotes.types";

export const formatCurrency = (value: number): string => {
  return new Intl.NumberFormat('en-US', { 
    style: 'currency', 
    currency: 'USD',
    maximumFractionDigits: 0
  }).format(value);
};

export const getStatusBadge = (status: QuoteStatus) => {
  switch (status) {
    case 'pending':
      return <Badge variant="outline" className="bg-slate-100">Pending Review</Badge>;
    case 'interested':
      return <Badge variant="outline" className="bg-blue-100 text-blue-800">Interested</Badge>;
    case 'accepted':
      return <Badge variant="outline" className="bg-green-100 text-green-800">Accepted</Badge>;
    case 'declined':
      return <Badge variant="outline" className="bg-red-100 text-red-800">Declined</Badge>;
    default:
      return <Badge variant="outline">Unknown</Badge>;
  }
};
